import React from "react";
import Icon from "../../../components/AppIcon";

const ProgressIndicator = ({ steps, currentStep }) => {
  return (
    <div className="w-full max-w-3xl mx-auto mb-8">
      <div className="flex items-center justify-center gap-4">
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isPast = stepNumber < currentStep;

          return (
            <React.Fragment key={step?.id}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center font-semibold transition-all ${isActive
                      ? "bg-primary text-primary-foreground scale-110 shadow-lg"
                      : isPast
                        ? "bg-success text-white"
                        : "bg-muted text-muted-foreground"
                    }`}
                >
                  {isPast ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <span>{stepNumber}</span>
                  )}
                </div>
                <div className="mt-2 text-center">
                  <div
                    className={`text-sm font-medium ${isActive
                        ? "text-primary"
                        : isPast
                          ? "text-success"
                          : "text-muted-foreground"
                      }`}
                  >
                    {step?.title}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {step?.description}
                  </div>
                </div>
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`h-1 w-24 rounded transition-all ${stepNumber < currentStep ? "bg-success" : "bg-muted"
                    }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;